import { jsonrepair } from 'jsonrepair';
import unescape from 'lodash.unescape';

import mapFilenameToLogType from './mapFilenameToLogType';

export const getLogConfig = (fileName, file) => {
  if (fileName.endsWith('.xml')) {
    return {
      language: mapFilenameToLogType(fileName),
      data: unescape(file),
    };
  }

  if (fileName.endsWith('.json') || fileName.endsWith('.har')) {
    return {
      language: 'json',
      data: JSON.stringify(file, null, 2),
    };
  }

  if (fileName === 'crash.log') {
    return {
      language: 'text',
      data: file,
    };
  }

  // sometimes automator.log contains JSON
  if (fileName.includes('automator') && fileName.includes('.log')) {
    if (typeof file === 'object') {
      return {
        language: 'json',
        data: JSON.stringify(file, null, 2),
      };
    }

    if (typeof file === 'string') {
      try {
        // we need to remove all whitespaces in order to get syntax highlighter working properly
        const parsed = JSON.parse(jsonrepair(file));

        if (typeof parsed !== 'object') {
          throw Error('File content is not a json');
        }

        return {
          language: 'json',
          data: JSON.stringify(parsed, null, 2),
        };
      } catch (e) {} // eslint-disable-line
    }
  }

  // axios will try to deserialize the response to JSON regardless of file type, response type, etc.
  // serialize the json object properly to prevent log output of [object Object]
  if (typeof file === 'object') {
    try {
      const data = JSON.stringify(file, null, 2);

      return {
        language: 'json',
        data,
      };
    } catch {
      // Ignore JSON serialization errors and fallback to default behaviour
      // of just rendering the data as is.
    }
  }

  return {
    language: mapFilenameToLogType(fileName),
    data: `${file}`,
  };
};

export default getLogConfig;
